import React from "react";
import "../Hero.css";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiShield,
  FiTrendingUp,
  FiCheckCircle,
  FiCpu,
  FiClock,
  FiLayers,
} from "react-icons/fi";

import heroImage from "../../assets/banner-4.png";

const Hero = () => {
  return (
    <section className="hero">

      <div className="container hero-container">

        {/* Left Content */}

        <div className="hero-content">

          <span className="hero-badge">
            <FiCheckCircle />
            Trusted Auxiliary FinTech Solutions
          </span>

          <h1>
            Empowering the Future of
            <span> Digital Finance</span>
          </h1>

          <p>
            Saivari Fintech Private Limited empowers banks, NBFCs, payment providers, fintech startups, and financial institutions with secure, scalable, and compliant auxiliary technology solutions. We help businesses streamline operations, enhance customer experiences, simplify regulatory compliance, and accelerate digital transformation through innovative, reliable, and future-ready fintech services
          </p>

          <div className="hero-buttons">

            <a href="/contact" className="primary-btn">
              Get Started
              <FiArrowRight />
            </a>

            <a href="/about" className="secondary-btn">
              Learn More
            </a>

          </div>

          <div className="hero-stats">

            <div>
              <h3>100%</h3>
              <span>Secure Solutions</span>
            </div>

            <div>
              <h3>24/7</h3>
              <span>Business Support</span>
            </div>

            <div>
              <h3>KYC</h3>
              <span>Compliance Focused</span>
            </div>



          </div>

        </div>

        {/* Right Image */}

        <div className="hero-image">

          <img
            src={heroImage}
            alt="Saivari Fintech"
          />

          <div className="floating-card card-one">
            <FiTrendingUp />
            <div>
              <h4>Business Growth</h4>
              <p>+98% Performance</p>
            </div>
          </div>

          <div className="floating-card card-two">
            <FiShield />
            <div>
              <h4>Secure Platform</h4>
              <p>256-bit Encryption</p>
            </div>
          </div>

        </div>

      </div>

    </section>
  );
};

export default Hero;